// extracted by mini-css-extract-plugin
export default {"container":"Contact_container__J1LZ1","divider":"Contact_divider__8pSjv"};